import React from "react";
class BannerBottomSteps extends React.Component {
  render() {
    return (
      <section
        className="section payPrecess"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center section_title payment-step">
                <h5
                  className="wherehome-white-billing SansSerif"
                >
                  <span
                    onClick={() => this.props.breadcrumbActive(2)}
                    className={this.props.status.step2 ? "active" : ""}
                  >
                    Billing Address
                  </span>
                  &nbsp;
                  <i className="mdi mdi-chevron-right" />
                  &nbsp;
                  <span
                    onClick={() => this.props.breadcrumbActive(4)}
                    className={this.props.status.step4 ? "active" : ""}
                  >
                    {" "}
                    Payment Method{" "}
                  </span>{" "}
                  &nbsp;
                  <i className="mdi mdi-chevron-right" />
                  &nbsp;{" "}
                  <span className={this.props.status.step5 ? "active" : ""}>
                    Order Confirmation
                  </span>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default BannerBottomSteps;



// WEBPACK FOOTER //
// ./src/pages/eSimCheckout/BannerBottomSteps.js